<template>
  <view class="checkbox-demo">
    <view-desc>默认勾选：{{ checkboxValue }}</view-desc>
    <view class="cube-checkbox-example">
      <cube-checkbox  wx:model="{{ checkboxValue }}" wx:model-prop="value">Default Checked</cube-checkbox>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    checkboxValue: true
  }
})
</script>

<style lang="stylus">
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-checkbox": "@mpxjs/mpx-cube-ui/src/components/checkbox/index"
    }
  }
</script>
